import { toast } from "react-toastify";
import {
  DELETE_ANON_PROTOCOL,
  DELETE_FILTER,
  DELETE_HL7_NODE,
  DELETE_PACS,
  DELETE_PACS_CONFIG,
  DELETE_PLATFORM_CONFIG,
  DELETE_ROUTER_CONFIG,
  DELETE_STUDY_LOGS,
  GET_ALL_CONFIGS,
  GET_ALL_FILTER,
  GET_ALL_PACS_CONFIG,
  GET_ALL_PLATFORM,
  GET_ALL_TIMEZONES,
  GET_ANON_PROTOCOLS,
} from "../../appConstants.js";
import axiosInstance from "../AxiosInstance/AxiosInstance";

// Get Anon Protocols
export const fetchAnonProtocols = async () => {
  const fetchData = async () => {
    try {
      const response = await axiosInstance.post(
        `${GET_ANON_PROTOCOLS}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.access_token}`,
          },
        }
      );
      return response;
    } catch (error) {
      toast.error(`Error: ${error.message}`, {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
  };

  const output = await fetchData();
  return output;
};

// Get Filters
export const fetchFilters = async () => {
  const fetchData = async () => {
    try {
      const response = await axiosInstance.post(
        `${GET_ALL_FILTER}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.access_token}`,
          },
        }
      );
      return response;
    } catch (error) {
      toast.error(`Error: ${error.message}`, {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
  };

  const output = await fetchData();
  return output;
};

// Get Pacs Configuration
export const fetchPacsConfiguration = async () => {
  const fetchData = async () => {
    try {
      const response = await axiosInstance.post(
        `${GET_ALL_PACS_CONFIG}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.access_token}`,
          },
        }
      );
      return response;
    } catch (error) {
      toast.error(`Error: ${error.message}`, {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
  };

  const output = await fetchData();
  return output;
};

// Get Platform Configs
export const fetchPlatformConfigs = async () => {
  const fetchData = async () => {
    try {
      const response = await axiosInstance.post(
        `${GET_ALL_PLATFORM}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.access_token}`,
          },
        }
      );
      return response;
    } catch (error) {
      toast.error(`Error: ${error.message}`, {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
  };

  const output = await fetchData();
  return output;
};

// Delete Data
export const deleteData = async (type, id) => {
  let path = "";
  if (type === "PacsTable") path = DELETE_PACS;
  if (type === "filtertable") path = DELETE_FILTER;
  if (type === "platformTable") path = DELETE_PLATFORM_CONFIG;
  if (type === "PacsConfigTable") path = DELETE_PACS_CONFIG;
  if (type === "AnonymizationProtocolTable") path = DELETE_ANON_PROTOCOL;
  if (type === "RouterConfigTable") path = DELETE_ROUTER_CONFIG;
  if (type === "NodeTable") path = DELETE_HL7_NODE;
  if (type === "Hl7Config") path = DELETE_HL7_NODE;

  if (type === "studylevellogs") {
    let body = {};
    body.ids = id;
    body.select_all = false;
    path = DELETE_STUDY_LOGS;
    const Deactivelogs = async () => {
      try {
        const response = await axiosInstance.post(`${path}`, body, {
          headers: {
            Authorization: `Bearer ${localStorage.access_token}`,
          },
        });
        if (response.data.success) {
          toast.success(`${response.data.message}`, {
            position: toast.POSITION.BOTTOM_CENTER,
          });
        }
      } catch (error) {
        toast.error(`Error: ${error.message}`, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
    };

    Deactivelogs();
  } else
    try {
      const response = await axiosInstance.delete(`${path}/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
        },
      });
      if (response.data.success) {
        toast.success(`${response.data.message}`, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      } else {
        toast.error(`Error: ${response.data.message}`, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`, {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
};

// Get Router Configs
export const fetchRouterConfigs = async () => {
  const fetchData = async () => {
    try {
      const response = await axiosInstance.post(
        `${GET_ALL_CONFIGS}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.access_token}`,
          },
        }
      );
      return response;
    } catch (error) {
      toast.error(`Error: ${error.message}`, {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
  };

  const output = await fetchData();
  return output;
};

export const fetchTimezones = async () => {
  const fetchData = async () => {
    try {
      const response = await axiosInstance.get(`${GET_ALL_TIMEZONES}`, {
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
        },
      });
      return response;
    } catch (error) {
      console.log(error);
    }
  };

  const output = await fetchData();
  return output;
};
